import { KeyValue } from 'ngrx-forms';
import { DxFormGroup } from '../form-group';
import { VALIDATOR_KEY } from './metadata-keys';
import { addToMetadata } from '@digitaix/helpers';
import { Without } from '@digitaix/types';

export type ValidatorResult = KeyValue | string | null;

export type ValidatorError = KeyValue | string;

export function Validator<T>(
  controlId: keyof Without<T, keyof DxFormGroup<any>>,
  validatorErrorTemplate?: string
) {
  return function(
    target: Partial<Without<T, keyof DxFormGroup<any>>>,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<ValidatorResult>
  ) {
    addToMetadata(
      VALIDATOR_KEY,
      {
        controlId: controlId.toString(),
        name: propertyKey,
        propertyKey,
        validatorErrorTemplate
      },
      target
    );
  };
}
